const DesignFacade = require('../../../facade/design/design');

module.exports = {
  listeners: {},

  initialize: function (RestrictionsFactory) {
    _.bindAll(this, 'onNewSource');
    this.restrictionsFactory = RestrictionsFactory;
    this.canvas = INKIVE.Tool.getInstance().editor.canvas;
  },

  refresh: function (permissions) {
    const restrictions = JSON.parse(permissions.get('restrictions') || '{}');
    const elementId = permissions.get('element_id');

    if (restrictions.source && restrictions.source.list) {
      this.listeners[elementId] || this.addListener(elementId, permissions);
    } else if (this.listeners[elementId]) {
      this.removeListener(elementId);
    }
  },

  removeListener: function (elementId) {
    this.listeners = _.omit(this.listeners, elementId);
    DesignFacade.off(elementId + '.resolution_optimized', this.onNewSource);
  },

  addListener: function (elementId, permissions) {
    this.listeners[elementId] = permissions;
    DesignFacade.on(elementId + '.resolution_optimized', this.onNewSource);
  },

  onNewSource: function (options) {
    const restrictions = JSON.parse(this.listeners[options.id].get('restrictions') || '{}');

    if (restrictions.source && restrictions.source.list) {
      const isAlreadyAdded = restrictions.source.list.find((data) => (
        data.source === options.source
      ));

      if (!isAlreadyAdded) {
        this.canvas.call('advice.show', 'source-restriction-applied');
        restrictions.source.list.push({
          thumbnail: options.thumb_src,
          source: options.source
        });

        this.restrictionsFactory.setGlobalElementRestriction(
          options.id, JSON.stringify(restrictions)
        );

        this.canvas.selectOnly([$('#' + options.id)[0]]);
      }
    } else if (this.listeners[options.id]) {
      this.removeListener(options.id);
    }
  }
};
